var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnel02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57358 4.77694C2.94194 4.07372 2.62612 3.72211 2.61365 3.42279C2.60283 3.16278 2.71409 2.91263 2.91445 2.74655C3.14509 2.55537 3.61771 2.55446 4.56295 2.55264L16.932 2.52883C17.8773 2.52701 18.3499 2.5261 18.5813 2.71639C18.7823 2.8817 18.8945 3.13142 18.8847 3.39147C18.8734 3.69083 18.5589 4.04366 17.93 4.7493L13.185 10.0731C13.0596 10.2137 12.997 10.2841 12.9523 10.3641C12.9127 10.435 12.8837 10.5114 12.8662 10.5907C12.8465 10.6802 12.8467 10.7744 12.847 10.9628L12.8556 15.4187C12.8559 15.5816 12.8561 15.6631 12.8299 15.7336C12.8068 15.7959 12.7692 15.8518 12.7201 15.8966C12.6645 15.9472 12.5889 15.9777 12.4377 16.0385L9.6066 17.1773C9.30055 17.3004 9.14752 17.3619 9.02454 17.3366C8.91699 17.3145 8.82252 17.2508 8.76168 17.1594C8.6921 17.0549 8.69178 16.8899 8.69115 16.56L8.68039 10.9708C8.68002 10.7824 8.67984 10.6882 8.65977 10.5988C8.64197 10.5195 8.61267 10.4433 8.57281 10.3725C8.52786 10.2927 8.46491 10.2226 8.339 10.0824L3.57358 4.77694Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel02);
export default __webpack_public_path__ + "static/media/filter-funnel-02.b9342417b783d83ae0bef4d013fd4e8d.svg";
export { ForwardRef as ReactComponent };